import UploadImage from './src/main'

export default UploadImage



// WEBPACK FOOTER //
// ./src/views/question-review/components/UploadImage/index.js